import { useEffect } from 'react'
import { notification } from 'sounds/index'
import { WebsocketEvent } from 'entities/WebSocket'
import { type IResponseCallQueueParticipant } from 'entities/Call'
import { useEntitiesContext } from 'entities/EntitiesExport'
import type { CallPopUpGlobalStore } from 'widgets/CallPopUp'

const notificationAudio = notification.getAudio('notificationCallQueue')

export const useEventCallQueueParticipantJoin = (callPopUpGlobalStore: CallPopUpGlobalStore) => {
  const { inboxesStore, usersStore, websocket, callStore } = useEntitiesContext()
  const handler = (data: IResponseCallQueueParticipant) => {
    inboxesStore.channelsInboxes.subscribeChannel(data.team.id)
    callPopUpGlobalStore.addQueueItem(data)

    const canPlayChime = !usersStore.isAwayStatus && !callStore.disabled && !callStore.isBusy
    if (canPlayChime) {
      notificationAudio.play()
    }
  }

  useEffect(() => websocket.on(WebsocketEvent.CallQueueParticipantJoin, handler), [])
}
